// material-ui
import AddIcon from '@mui/icons-material/Add'
import {
  FormControl,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Tooltip,
} from '@mui/material'
import { styled, useTheme } from '@mui/material/styles'
import React from 'react'
import { useParams } from 'react-router-dom'

import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings'
import CancelIcon from '@mui/icons-material/Cancel'
import EmailIcon from '@mui/icons-material/Email'
import {
  Avatar,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  Typography,
} from '@mui/material'
import { red } from '@mui/material/colors'
import ElevationScroll from 'components/ElevationScroll'
import * as groups from 'groups'
import { gridSpacing } from 'store/constant'
import TitleService from 'title-service'
import SecondaryAction from 'ui-component/cards/CardSecondaryAction'
import MainCard from 'ui-component/cards/MainCard'
import SubCard from 'ui-component/cards/SubCard'
import * as validation from 'validation'

// assets
import * as autoThunks from 'features/auto-thunks'
import { useEffect } from 'react'

import Busy from 'components/Busy'
import { getUserClaims } from 'features/application/application-slice'
import {
  get_all_contentHouse,
  get_selected_contentHouse,
  setSelectedcontentHouse,
} from 'features/contentHouse/contentHouse-slice'
import { useDispatch, useSelector } from 'react-redux'

// ================================|| UI LIST - SIMPLE LIST ||================================ //

const ListWrapper = styled('div')(({ theme }) => ({
  padding: '15px 0',
  borderBottom: theme.palette.mode === 'dark' ? 'none' : '1px solid',
  borderTop: theme.palette.mode === 'dark' ? 'none' : '1px solid',
  borderColor: `${theme.palette.grey[100]}!important`,
}))
export default function SimpleList() {
  // Generate Grid
  const theme = useTheme()
  const params = useParams()
  let dispatch = useDispatch()
  let claims = useSelector(getUserClaims)
  let contentHouse_list = useSelector(get_all_contentHouse)
  let contentHouse = useSelector(get_selected_contentHouse)
  const [openToggleAdminDialog, setOpenToggleAdminDialog] = React.useState(null)
  const [inviteFormOpen, setInviteFormOpen] = React.useState(null)
  const [inviteEmail, setInviteEmail] = React.useState(null)
  const [inviteFormDisabled, setInviteFormDisabled] = React.useState(null)
  const [displayInvitees, setDisplayInvitees] = React.useState(null)
  const [openCancelInvitationDialog, setOpenCancelInvitationDialog] =
    React.useState(null)
  const [toggleAdminArgs, setToggleAdminArgs] = React.useState(null)

  useEffect(() => {
    if (claims?.user && params?.id) {
      dispatch(
        autoThunks.load_existing_content_houses_for_membership({
          fire_user: claims?.user,
          contentHouseId: params?.id,
        }),
      )
    }
  }, [claims?.user, params?.id])
  useEffect(() => {
    function set_local_content_house() {
      let contentHouse = contentHouse_list.find((x) => x.id === params.id)
      if (contentHouse) {
        dispatch(setSelectedcontentHouse(contentHouse.id))
      }
    }
    set_local_content_house()
  }, [contentHouse_list, contentHouse?.id])
  useEffect(() => {
    function is_inviteForm_valid() {
      if (inviteEmail && validation.validateEmail(inviteEmail)) {
        setInviteFormDisabled(false)
      } else {
        setInviteFormDisabled(true)
      }
    }
    is_inviteForm_valid()
  }, [contentHouse_list, contentHouse?.id, inviteEmail])
  useEffect(() => {
    function show_invitees() {
      let contentHouse = contentHouse_list.find((x) => x.id === params.id)
      if (contentHouse?.invitees?.length) {
        setDisplayInvitees(true)
      } else {
        setDisplayInvitees(false)
      }
    }
    show_invitees()
  }, [contentHouse_list, contentHouse?.id])
  useEffect(() => {
    if (claims?.user && toggleAdminArgs) {
      dispatch(
        autoThunks.toggle_admin_for_user({
          fire_user: claims?.user,
          contentHouseId: (() => {
            function getContentHouseId(): string {
              return contentHouse?.id
            }
            return getContentHouseId()
          })(),
          user_id: (() => {
            function gettoggleAdminArgs(): string {
              return toggleAdminArgs
            }
            return gettoggleAdminArgs()
          })(),
        }),
      )
    }
  }, [claims?.user, toggleAdminArgs])

  function MemberListItem(): any {
    return (item, index) => {
      return (
        <React.Fragment key={index}>
          <Grid item xs={12}>
            <MemberInstance
              contentHouse={contentHouse}
              item={item}
              setToggleAdminArgs={(id) => {
                setToggleAdminArgs(id)
              }}
            />
          </Grid>
        </React.Fragment>
      )
    }
  }

  let output_MemberListItem = MemberListItem()

  function onSave(context) {
    return () =>
      autoThunks.send_invitation_for_user({
        fire_user: claims?.user,
        contentHouseId: (() => {
          function getContentHouseId(): string {
            return contentHouse?.id
          }
          return getContentHouseId()
        })(),
        email: (() => {
          function getContentHouseId(): string {
            return inviteEmail
          }
          return getContentHouseId()
        })(),
      })
  }
  function inviteForm(onSave: any): any {
    return (
      <Grid item sx={{ width: 342, margin: { xs: '0 auto', md: 'initial' } }}>
        <ElevationScroll>
          <SubCard
            sx={{
              background:
                theme.palette.mode === 'dark'
                  ? theme.palette.dark.main
                  : theme.palette.grey[50],
              width: '100%',
              maxWidth: 342,
            }}
            content={false}
          >
            <Grid container spacing={gridSpacing} sx={{ p: 3 }}>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <InputLabel>{TitleService('Email')}</InputLabel>
                  <OutlinedInput
                    value={inviteEmail}
                    onChange={(e) => {
                      setInviteEmail(e.target.value)
                    }}
                    type="text"
                    label={TitleService('Email')}
                    startAdornment={
                      <InputAdornment position="start">
                        <EmailIcon />
                      </InputAdornment>
                    }
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <Grid container spacing={1}>
                  <Grid item xs={6}>
                    <Button
                      disabled={inviteFormDisabled}
                      variant="contained"
                      fullWidth
                      onClick={async () => {
                        if (!inviteFormDisabled) {
                          setInviteFormOpen(false)
                          await dispatch(onSave({ inviteEmail })())
                          setInviteEmail('')
                        }
                      }}
                    >
                      {TitleService('Invite')}
                    </Button>
                  </Grid>
                  <Grid item xs={6}>
                    <Button
                      variant="outlined"
                      fullWidth
                      onClick={() => {
                        setInviteEmail('')
                        setInviteFormOpen(false)
                      }}
                    >
                      {TitleService('Cancel')}
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </SubCard>
        </ElevationScroll>
      </Grid>
    )
  }

  let output_inviteForm = inviteForm(onSave)

  function subcard(item: any, inviteForm: any): any {
    return (
      <>
        <Grid container alignItems="center" spacing={gridSpacing}>
          <Grid
            item
            xs={inviteFormOpen ? 6 : 12}
            zeroMinWidth
            sx={{
              display: inviteFormOpen ? { xs: 'none', md: 'block' } : 'block',
            }}
          >
            <Grid container alignItems="center" spacing={gridSpacing}>
              {(contentHouse?.members || []).map((member, index) =>
                item(member, index),
              )}
            </Grid>
          </Grid>
          {inviteFormOpen && (
            <Grid item xs={6}>
              {inviteForm}
            </Grid>
          )}
        </Grid>
      </>
    )
  }

  let output_subcard = subcard(output_MemberListItem, output_inviteForm)

  function cancelInvitation(context) {
    return () =>
      autoThunks.cancel_invitee_invitation({
        userId: claims?.user,
        contentHouseId: (() => {
          function getContentHouseId(): string {
            return contentHouse?.id
          }
          return getContentHouseId()
        })(),
        inviteeId: (() => {
          function getItemId(): string {
            return context.item?.id
          }
          return getItemId()
        })(),
      })
  }
  function InviteeInstance(cancelInvitation: any): any {
    return (item: any) => {
      let group: any = null
      let role = ''
      if (contentHouse) {
        group = new groups.ContentHouseGroup(contentHouse)
        if (group.isAdmin(item?.id)) {
          role = TitleService(role)
        }
      }
      return (
        <ListWrapper>
          <Grid container alignItems="center" spacing={gridSpacing}>
            <Grid
              item
              xs={12}
              sm={6}
              onClick={() => {}}
              style={{ cursor: 'pointer' }}
            >
              <Grid
                container
                alignItems="center"
                spacing={gridSpacing}
                sx={{ flexWrap: 'nowrap' }}
              >
                <Grid item>
                  <Avatar
                    alt={item.name}
                    src={item?.profileImage}
                    sx={{ width: 48, height: 48 }}
                  />
                </Grid>
                <Grid item sm zeroMinWidth>
                  <Grid container spacing={0}>
                    <Grid item xs={12}>
                      <Typography variant="h4" component="div">
                        {item.name}
                      </Typography>
                    </Grid>
                    <Grid item xs={12}>
                      <Typography variant="caption">{role}</Typography>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Grid
                container
                spacing={1}
                sx={{
                  justifyContent: 'flex-end',
                  [theme.breakpoints.down('md')]: {
                    justifyContent: 'flex-start',
                  },
                }}
              >
                <Grid item>
                  <Tooltip placement="top" title="Message">
                    <Button
                      variant="outlined"
                      onClick={() => {
                        setOpenCancelInvitationDialog(true)
                      }}
                      sx={{
                        minWidth: 32,
                        height: 32,
                        p: 0,
                      }}
                    >
                      <CancelIcon fontSize="small" sx={{ color: red[500] }} />
                    </Button>
                  </Tooltip>
                  <Dialog
                    open={openCancelInvitationDialog}
                    onClose={() => {
                      setOpenCancelInvitationDialog(false)
                    }}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                    sx={{ p: 3 }}
                  >
                    <DialogTitle id="alert-dialog-title">
                      {TitleService('Cancel invitation')}
                    </DialogTitle>
                    <DialogContent>
                      <DialogContentText id="alert-dialog-description">
                        <Typography variant="body2" component="span">
                          {TitleService(`to ${item.name}`)}
                        </Typography>
                      </DialogContentText>
                    </DialogContent>
                    <DialogActions sx={{ pr: 2.5 }}>
                      <Button
                        sx={{
                          color: theme.palette.error.dark,
                          borderColor: theme.palette.error.dark,
                        }}
                        onClick={() => {
                          setOpenCancelInvitationDialog(false)
                        }}
                        color="secondary"
                      >
                        {TitleService('Cancel')}
                      </Button>
                      <Button
                        variant="contained"
                        size="small"
                        onClick={async () => {
                          await dispatch(cancelInvitation({ item })())
                          setOpenCancelInvitationDialog(false)
                        }}
                        autoFocus
                      >
                        {TitleService('Are you sure?')}
                      </Button>
                    </DialogActions>
                  </Dialog>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </ListWrapper>
      )
    }
  }

  let output_InviteeInstance = InviteeInstance(cancelInvitation)

  function InviteeListItem(inviteeItem: any): any {
    return (item, index) => {
      return (
        <React.Fragment key={index}>
          <Grid item xs={12}>
            {inviteeItem(item)}
          </Grid>
        </React.Fragment>
      )
    }
  }

  let output_InviteeListItem = InviteeListItem(output_InviteeInstance)

  function render_invitees(inviteeItem: any): any {
    return (
      <>
        <Grid
          item
          xs
          zeroMinWidth
          sx={{
            display: inviteFormOpen ? { xs: 'none', md: 'block' } : 'block',
          }}
        >
          <Grid container alignItems="center" spacing={gridSpacing}>
            {(contentHouse?.invitees || []).map((member, index) =>
              inviteeItem(member, index),
            )}
          </Grid>
        </Grid>
      </>
    )
  }

  let output_render_invitees = render_invitees(output_InviteeListItem)

  function grid(child1: any, child2: any): any {
    return (
      <Grid container spacing={gridSpacing}>
        <Busy />
        <Grid item xs={12} lg={displayInvitees ? 6 : 12}>
          <MainCard
            title={TitleService('Membership')}
            secondary={
              <SecondaryAction
                icon={
                  <AddIcon
                    onClick={() => {
                      setInviteFormOpen(!inviteFormOpen)
                    }}
                  />
                }
              />
            }
          >
            <Grid container spacing={gridSpacing}>
              <Grid item xs={12}>
                {child1}
              </Grid>
            </Grid>
          </MainCard>
        </Grid>
        {displayInvitees && (
          <Grid item lg={6} xs={12}>
            <MainCard title={TitleService('Invitations')}>{child2}</MainCard>
          </Grid>
        )}
      </Grid>
    )
  }

  let output_grid = grid(output_subcard, output_render_invitees)

  return output_grid
}

function MemberInstance(props: {
  item: any
  contentHouse: any
  setToggleAdminArgs: any
}) {
  let group: any = null
  const theme = useTheme()
  const [openToggleAdminDialog, setOpenToggleAdminDialog] = React.useState(null)
  let role = ''
  let isAdmin = false
  let { contentHouse, item, setToggleAdminArgs } = props
  if (contentHouse) {
    group = new groups.ContentHouseGroup(contentHouse)
    if (group.isAdmin(item?.id)) {
      role = TitleService(role)
      isAdmin = true
    }
  }
  return (
    <ListWrapper>
      <Grid container alignItems="center" spacing={gridSpacing}>
        <Grid
          item
          xs={12}
          sm={6}
          onClick={() => {}}
          style={{ cursor: 'pointer' }}
        >
          <Grid
            container
            alignItems="center"
            spacing={gridSpacing}
            sx={{ flexWrap: 'nowrap' }}
          >
            <Grid item>
              <Avatar
                alt={item.name}
                src={item?.profileImage}
                sx={{ width: 48, height: 48 }}
              />
            </Grid>
            <Grid item sm zeroMinWidth>
              <Grid container spacing={0}>
                <Grid item xs={12}>
                  <Typography variant="h4" component="div">
                    {item.name}
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography variant="caption">{role}</Typography>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12} sm={6}>
          <Grid
            container
            spacing={1}
            sx={{
              justifyContent: 'flex-end',
              [theme.breakpoints.down('md')]: {
                justifyContent: 'flex-start',
              },
            }}
          >
            <Grid item>
              <Tooltip placement="top" title="Message">
                <Button
                  variant="outlined"
                  onClick={async () => {
                    setOpenToggleAdminDialog(true)
                  }}
                  sx={{
                    minWidth: 32,
                    height: 32,
                    p: 0,
                  }}
                >
                  <AdminPanelSettingsIcon
                    color={isAdmin ? 'success' : 'default'}
                    fontSize="smisAdminall"
                  />
                </Button>
              </Tooltip>
              <Dialog
                open={openToggleAdminDialog}
                onClose={() => {
                  setOpenToggleAdminDialog(false)
                }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                sx={{ p: 3 }}
              >
                <DialogTitle id="alert-dialog-title">
                  {isAdmin ? TitleService('Demote') : TitleService('Promote')}
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    <Typography variant="body2" component="span">
                      {TitleService(`${item.name} to admin.`)}
                    </Typography>
                  </DialogContentText>
                </DialogContent>
                <DialogActions sx={{ pr: 2.5 }}>
                  <Button
                    sx={{
                      color: theme.palette.error.dark,
                      borderColor: theme.palette.error.dark,
                    }}
                    onClick={() => {
                      setOpenToggleAdminDialog(false)
                    }}
                    color="secondary"
                  >
                    {TitleService('Cancel')}
                  </Button>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={async () => {
                      setToggleAdminArgs(item?.id)
                      setOpenToggleAdminDialog(false)
                    }}
                    autoFocus
                  >
                    {TitleService('Are you sure?')}
                  </Button>
                </DialogActions>
              </Dialog>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </ListWrapper>
  )
}
